/**
 * 配置文件 环境变量的集中地
 * tzw 2017年5月22日13:57:44
 */

export default {
  // api前缀
  API_HOST: process.env.API_HOST,
  PC_ENV: process.env.PC_ENV,
  H5_ENV: process.env.H5_ENV,
  // node版本 竹马相关的api前缀
  NODE_ZHUMA_API_HOST: process.env.NODE_ZHUMA_API_HOST,
  // node版本 众合相关的api前缀
  NODE_ZHONGHESCHOOL_API_HOST: process.env.NODE_ZHONGHESCHOOL_API_HOST,
  // 不使用java-api版本
  ZHONGHESCHOOL_API_HOST: process.env.ZHONGHESCHOOL_API_HOST,
  // 是否是调试模式
  DEBUG: process.env.IS_DEV === true || process.env.IS_DEV === 'true',
  // 是否开启服务器端渲染
  SSR: process.env.IS_SSR === true || process.env.IS_SSR === 'true'
}
